import React from 'react';

const AboutSection = ({ about, whatIDo }) => {
  return (
    <section
      id="about"
      className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 py-12 lg:py-14 border-b-2 divider-line"
    >
      {/* About me */}
      <div
        className="
          lg:col-span-5
          border-b lg:border-b-0
          lg:border-r
          divider-line
          pb-8 lg:pb-0
          lg:pr-10
        "
      >
        <p className="text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui font-medium text-[#8b2331]">
          {about.label}
        </p>

        <h3 className="font-serif-display text-[32px] sm:text-[36px] leading-[1.15] text-[#0f0f0f] mt-5 whitespace-pre-line">
          {about.heading}
        </h3>

        <div className="border-t divider-line mt-6 pt-5">
          <p className="font-serif-body text-[16px] sm:text-[17px] leading-relaxed text-[#2a2a2a]">
            {about.body}
          </p>
        </div>
      </div>

      {/* My Expertise */}
      <div
        id="services"
        className="lg:col-span-7 lg:pl-2"
      >
        <p className="text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui font-medium text-[#8b2331]">
          {whatIDo.label}
        </p>

        <ul className="mt-5 lg:mt-6 divide-y divide-[#1a1a1a]/25 border-t border-b divider-line">
          {whatIDo.items.map((item, i) => (
            <li
              key={i}
              className="flex items-baseline gap-4 sm:gap-6 py-3.5"
            >
              <span className="text-[9px] sm:text-[10px] tracking-[0.3em] font-sans-ui text-[#8b2331] w-7 sm:w-8 shrink-0">
                {String(i + 1).padStart(2, '0')}
              </span>

              <span className="font-serif-display text-[23px] sm:text-[26px] leading-tight text-[#0f0f0f]">
                {item}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default AboutSection;
